document.addEventListener( 'DOMContentLoaded', () => {
    const ccVideoFiltersCombos = new Combobo({
        inputClass: 'combobox browser-default', // `browser-default` is required so Materialize doesn't take over
        select: '.CCVideoFilters-combo',
        selectOnly: false,
        toggleButtonIcon: '<span class="icon icon-fa-angle-down"></span>',
        optionValue: 'matching-text',
    });

    for (const [key, combo] of Object.entries(ccVideoFiltersCombos)) {
        combo.on('selection', function (selectedOption) {
            const form = document.querySelector('#content .filter-nav form');

            let hiddenInput = form.querySelector(`input[name="${combo.selectElm.id}"]`);
            if (selectedOption.value === '') {
                if (hiddenInput) {
                    hiddenInput.remove();
                }
            } else {
                if (!hiddenInput) {
                    hiddenInput = document.createElement('input');
                    hiddenInput.type = 'hidden';
                    hiddenInput.name = combo.selectElm.id;
                    form.appendChild(hiddenInput);
                }
                hiddenInput.value = selectedOption.value;    
            }

            form.submit();
        });
    }
});